"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const GeoEntities_1 = require("../../../../abstract/Models/GeoEntities");
class GISArea {
    constructor(obj) {
        this.meta = obj.meta || {};
        this.status = obj.status || {};
        this.geodata = obj.geodata || '';
        this.life_cycle_area = obj.life_cycle_area || [];
        this.samplingPoints = obj.samplingPoints || [];
        this.metadata_information_issues = obj.metadata_information_issues || [];
        this.fields = !obj.fields ? [] : obj.fields.map((fieldObj) => new GeoEntities_1.Field(fieldObj));
    }
}
exports.default = GISArea;
// 1. Mark as shipped
// 2. Share in giscloud
// 3. Zones in map
// 4. Upload GIS
